import { db, auth } from "../utils/firebase";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  query,
  where,
  setDoc,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { uuidv4 } from "@firebase/util";
import LogOutButton from "./LogOutButton";

export default function VerifiedMemberPage({ user }) {
  const {
    name: { given_name, family_name },
    userTypeName,
    community,
    email_address,
    password,
    postal_code,
    city,
    street,
    country,
    region,
  } = user;

  const [newGivenName, setNewGivenName] = useState(given_name);
  const [newFamilyName, setNewFamilyName] = useState(family_name);

  const userCommunityChanger = doc(db, "Users", auth.currentUser.uid);
  const [newCommunity, setNewCommunity] = useState(community);
  const [communitiesList, setCommunitiesList] = useState([]);
  const [detailsVis, setDetailsVis] = useState(true);
  const [adminList, setAdminList] = useState([]);
  const [editing, setEditing] = useState(false);

  const getAdminList = query(
    collection(db, "Users"),
    where("userTypeNumber", "==", 4)
  );

  useEffect(() => {
    async function changeCommunity() {
      await updateDoc(userCommunityChanger, { community: newCommunity });
    }
    changeCommunity();

    async function getAdmins(list) {
      const shot = await getDocs(list);
      const shots = shot.docs.filter(
        (admin) => admin.data().community == community
      );
      setAdminList(shots);
    }

    getAdmins(getAdminList);
  }, [newCommunity]);

  const updateUser = async () => {
    await updateDoc(userCommunityChanger, {
      name: {
        given_name: newGivenName,
        family_name: newFamilyName,
      },
    });
    setNewGivenName(newGivenName);
    setNewFamilyName(newFamilyName);
  };

  // const requestBoardMember = async (admin) => {
  //   await setDoc(doc(db, "mail", "Board Member Request" + uuidv4()), {
  //     to: admin,
  //     message: {
  //       subject: `${
  //         firstName + " " + lastName
  //       } has requested to become a board member`,
  //       html: `${
  //         firstName + " " + lastName
  //       } has requested to become a board member 🎯`,
  //     },
  //   });
  //   alert("Request Sent");
  // };

  return (
    <div className="bg-user-home text-center">
      <h1 style={{ marginBottom: 32 }}>Dashboard</h1>
      <>
        {" "}
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-4">
              <div id="myDetails" className="round-border">
                {editing ? (
                  <>
                    <label>First Name:</label>
                    {"  "}
                    <input
                      type="text"
                      placeholder="First Name"
                      defaultValue={newGivenName}
                      onChange={(e) => setNewGivenName(e.target.value)}
                    />

                    <label>Last Name:</label>
                    {"  "}
                    <input
                      type="text"
                      placeholder="Last Name"
                      defaultValue={newFamilyName}
                      onChange={(e) => setNewFamilyName(e.target.value)}
                    />
                    <div>Role: {userTypeName}</div>
                    <div>Email: {email_address}</div>
                    <label>Address:</label>
                    {"  "}

                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setEditing(!editing);
                        updateUser();
                      }}
                    >
                      Save
                    </button>
                  </>
                ) : (
                  <>
                    <div className="profileDetailsWrapper">
                      <div className="profileDetails">
                        <b>Name:</b> {newGivenName} {newFamilyName}
                      </div>
                      <div className="profileDetails">
                        <span>Role:</span> {userTypeName}
                      </div>
                      <div className="profileDetails">
                        <span>Email:</span> {email_address}
                      </div>
                      {/* <div className="profileDetails">
                        <span>Address:</span> {newAddress}
                      </div> */}
                      {/* <div className="profileDetails">
                        <span>Phone Number: {newPhoneNumber}</span>
                      </div> */}
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          setEditing(!editing);
                        }}
                      >
                        Edit Info
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </>

      <LogOutButton />
    </div>
  );
}
